const BORDER_COLOR = '#374151';
const options = {
  colorPalette: [
    { content: 'transparent', icon: './assets/transparent-icon.svg' },
    { content: '#000000' },
    { content: '#1B1B1B' },
    { content: '#353535' },
    { content: '#626262' },
    { content: '#D4D4D4' },
    { content: '#E4ECF7' },
    { content: '#FFFFFF' },
    { content: '#F5242C' },
    { content: '#7E4AD3' },
    { content: '#FB54A9' },
    { content: '#33B6D1' },
    { content: '#2A3A4E' },
    { content: '#3771B8' },
    { content: '#F27F31' },
    { content: '#1CA25D' },
  ],
  modules: [],
  colorPaletteReset: [
    { content: 'transparent', icon: './assets/no-color-icon.svg' },
    { content: '#000000' },
    { content: '#1B1B1B' },
    { content: '#353535' },
    { content: '#626262' },
    { content: '#D4D4D4' },
    { content: '#E4ECF7' },
    { content: '#FFFFFF' },
    { content: '#F5242C' },
    { content: '#7E4AD3' },
    { content: '#FB54A9' },
    { content: '#33B6D1' },
    { content: '#2A3A4E' },
    { content: '#3771B8' },
    { content: '#F27F31' },
    { content: '#1CA25D' },
  ],
  fontWeight: [
    { value: '300', content: '<span style="font-weight: 300">Light</span>' },
    { value: 'Normal', content: '<span style="font-weight: Normal">Normal</span>' },
    { value: 'Bold', content: '<span style="font-weight: Bolder">Bold</span>' },
  ],
  fontFamily: [
    { value: 'Open Sans', content: '<span style="font-family: Open Sans">Open Sans</span>' },
    { value: 'DM Sans', content: '<span style="font-family: DM Sans">DM Sans</span>' },
    { value: 'Roboto Flex', content: '<span style="font-family: Roboto Flex">Roboto Flex</span>' },
  ],
  strokeStyle: [
    { value: '0', content: 'Solid' },
    { value: '2,5', content: 'Dotted' },
    { value: '10,5', content: 'Dashed' },
  ],
  side: [
    { value: 'top', content: 'Top Side' },
    { value: 'right', content: 'Right Side' },
    { value: 'bottom', content: 'Bottom Side' },
    { value: 'left', content: 'Left Side' },
  ],
  portLabelPositionRectangle: [
    { value: { name: 'top', args: { y: -12 } }, content: 'Above' },
    { value: { name: 'right', args: { y: 0 } }, content: 'On Right' },
    { value: { name: 'bottom', args: { y: 12 } }, content: 'Below' },
    { value: { name: 'left', args: { y: 0 } }, content: 'On Left' },
  ],
  portLabelPositionEllipse: [
    { value: 'radial', content: 'Horizontal' },
    { value: 'radialOriented', content: 'Angled' },
  ],
  imageIcons: [
    { value: './assets/image-icon1.svg', content: '<img height="42px" src="./assets/image-icon1.svg"/>' },
    { value: './assets/image-icon2.svg', content: '<img height="80px" src="./assets/image-icon2.svg"/>' },
    { value: './assets/image-icon3.svg', content: '<img height="80px" src="./assets/image-icon3.svg"/>' },
    { value: './assets/image-icon4.svg', content: '<img height="80px" src="./assets/image-icon4.svg"/>' },
  ],
  imageGender: [
    {
      value: './assets/member-male.png',
      content: '<img height="50px" src="./assets/member-male.png" ' + 'style="margin: 5px 0 0 2px;"/>',
    },
    {
      value: './assets/member-female.png',
      content: '<img height="50px" src="./assets/member-female.png" ' + 'style="margin: 5px 0 0 2px;"/>',
    },
  ],
  arrowheadSize: [
    { value: 'M 0 0 0 0', content: 'None' },
    { value: 'M 0 -3 -6 0 0 3 z', content: 'Small' },
    { value: 'M 0 -5 -10 0 0 5 z', content: 'Medium' },
    { value: 'M 0 -10 -15 0 0 10 z', content: 'Large' },
  ],
  strokeWidth: [
    {
      value: 1,
      content: `<div style="background:${BORDER_COLOR};width:2px;height:30px;margin:0 14px;border-radius: 2px;"/>`,
    },
    {
      value: 2,
      content: `<div style="background:${BORDER_COLOR};width:4px;height:30px;margin:0 13px;border-radius: 2px;"/>`,
    },
    {
      value: 4,
      content: `<div style="background:${BORDER_COLOR};width:8px;height:30px;margin:0 11px;border-radius: 2px;"/>`,
    },
    {
      value: 8,
      content: `<div style="background:${BORDER_COLOR};width:16px;height:30px;margin:0 8px;border-radius: 2px;"/>`,
    },
  ],
  router: [
    {
      value: 'normal',
      content: `<p style="background:${BORDER_COLOR};width:2px;height:30px;margin:0 14px;border-radius: 2px;"/>`,
      attrs: {
        '.select-button-group-button': {
          'data-tooltip': 'Normal',
          'data-tooltip-position': 'right',
          'data-tooltip-position-selector': '.inspector-container',
        },
      },
    },
    {
      value: 'normal',
      content:
        `<p style="width:20px;height:30px;margin:0 5px;` +
        `border-bottom: 2px solid ${BORDER_COLOR};border-left: 2px solid ${BORDER_COLOR};"/>`,
      attrs: {
        '.select-button-group-button': {
          'data-tooltip': 'normal',
          'data-tooltip-position': 'right',
          'data-tooltip-position-selector': '.inspector-container',
        },
      },
    },
    {
      value: 'normal',
      content:
        `<p style="width:20px;height:30px;margin:0 5px;` + `border: 2px solid ${BORDER_COLOR};border-top: none;"/>`,
      attrs: {
        '.select-button-group-button': {
          'data-tooltip': 'Right Angle',
          'data-tooltip-position': 'right',
          'data-tooltip-position-selector': '.inspector-container',
        },
      },
    },
  ],
  connector: [
    {
      value: 'normal',
      content:
        `<p style="width:20px;height:20px;margin:5px;` +
        `border-top:2px solid ${BORDER_COLOR};` +
        `border-left:2px solid ${BORDER_COLOR};"/>`,
      attrs: {
        '.select-button-group-button': {
          'data-tooltip': 'Normal',
          'data-tooltip-position': 'right',
          'data-tooltip-position-selector': '.inspector-container',
        },
      },
    },
    {
      value: 'rounded',
      content:
        `<p style="width:20px;height:20px;margin:5px;` +
        `border-top-left-radius:30%;` +
        `border-top:2px solid ${BORDER_COLOR};` +
        `border-left:2px solid ${BORDER_COLOR};"/>`,
      attrs: {
        '.select-button-group-button': {
          'data-tooltip': 'Rounded',
          'data-tooltip-position': 'right',
          'data-tooltip-position-selector': '.inspector-container',
        },
      },
    },
    {
      value: 'smooth',
      content:
        `<p style="width:20px;height:20px;margin:5px;` +
        `border-top-left-radius:100%;` +
        `border-top:2px solid ${BORDER_COLOR};` +
        `border-left:2px solid ${BORDER_COLOR};"/>`,
      attrs: {
        '.select-button-group-button': {
          'data-tooltip': 'Smooth',
          'data-tooltip-position': 'right',
          'data-tooltip-position-selector': '.inspector-container',
        },
      },
    },
  ],
  labelPosition: [
    { value: 30, content: 'Close to source' },
    { value: 0.5, content: 'In the middle' },
    { value: -30, content: 'Close to target' },
  ],
  portMarkup: [
    {
      value: [
        {
          tagName: 'rect',
          selector: 'portBody',
          attributes: {
            width: 20,
            height: 20,
            x: -10,
            y: -10,
          },
        },
      ],
      content: 'Rectangle',
    },
    {
      value: [
        {
          tagName: 'circle',
          selector: 'portBody',
          attributes: {
            r: 10,
          },
        },
      ],
      content: 'Circle',
    },
    {
      value: [
        {
          tagName: 'path',
          selector: 'portBody',
          attributes: {
            d: 'M -10 -10 10 -10 0 10 z',
          },
        },
      ],
      content: 'Triangle',
    },
  ],
};

export { options };

const commonProperties = {
  name: {
    type: 'text',
    label: 'Type de sous-fonction',
    group: 'common',
    path: 'customAttributes/name',
    required: true,
    readOnly: true,
    defaultValue: '',
  },
  cellName: {
    type: 'text',
    label: 'Nom',
    group: 'common',
    path: 'customAttributes/cellName',
    required: true,
    defaultValue: '',
  },
  module: {
    type: 'select-box',
    label: 'Module',
    group: 'common',
    options: () => options.modules,
    path: 'customAttributes/module',
    defaultValue: '',
    required: true,
  },
  capacityPerHour: {
    type: 'number',
    label: 'Capacité Globale (bagages/heure)',
    group: 'common',
    path: 'customAttributes/capacityPerHour',
    required: true,
    min: 1,
  },
  parallelism: {
    type: 'number',
    label: 'Parallélisme',
    group: 'common',
    path: 'customAttributes/parallelism',
    min: 1,
  },
  duration: {
    type: 'number',
    label: 'Durée (secondes)',
    group: 'common',
    path: 'customAttributes/duration',
    min: 1,
  },
};
const outagesProperties = {
  outages: {
    type: 'button',
    group: 'Pannes',
    label: 'Edition pannes',
    render: true,
    action: (cell, graph) => {
      window.dispatchEvent(new CustomEvent('openOutagesDialog', { detail: { cell, graph } }));
    },
  },
};
const destinationProperties = {
  destination: {
    type: 'destinationField',
    label: 'Destination',
    group: 'destination',
    path: 'destination',
  },
};
// Groupes communs pour tous les inspecteurs
const commonGroups = {
  common: {
    label: 'Propriétés communes',
    index: 1,
  },
  specific: {
    label: 'Propriétés spécifiques',
    index: 2,
  },
  destination: {
    label: 'Destination',
    index: 4,
  },
  outagesGroup: {
    label: 'Pannes',
    index: 3,
  },
};

export const inspectorDefinitions = {
  'standard.Rectangle': {
    inputs: {
      ...commonProperties,
      ...outagesProperties,
      ...destinationProperties,
    },
    groups: commonGroups,
  },
  'appShapes.Div': {
    inputs: {
      ...commonProperties,
      ...outagesProperties,
      moduleForBaggageRoutingRule: {
        type: 'select-box',
        label: 'Module utilisé pour les règles de routage',
        group: 'specific',
        options: () => options.modules,
        path: 'moduleForBaggageRoutingRule',
        required: false,
        defaultValue: '',
      },
      maxRecirculations: {
        type: 'number',
        label: 'Max recirculations',
        group: 'specific',
        path: 'maxRecirculations',
        required: false,
        min: 0,
        defaultValue: '',
      },
      ...destinationProperties,
    },

    groups: commonGroups,
  },
  'appShapes.Tri': {
    inputs: {
      name: {
        type: 'text',
        label: 'Type de sous-fonction',
        group: 'common',
        path: 'customAttributes/name',
        required: true,
        readOnly: true,
        defaultValue: '',
      },
      cellName: {
        type: 'text',
        label: 'Nom',
        group: 'common',
        path: 'customAttributes/cellName',
        required: true,
        defaultValue: '',
      },
      module: {
        type: 'select-box',
        label: 'Module',
        group: 'common',
        options: () => options.modules,
        path: 'customAttributes/module',
        defaultValue: '',
        required: true,
      },
      parallelism: {
        type: 'number',
        label: 'Parallélisme',
        group: 'common',
        path: 'customAttributes/parallelism',
        min: 1,
      },
      ...outagesProperties,
      sens: {
        type: 'select-box',
        label: 'Sens de rotation',
        group: 'specific',
        path: 'sens',
        options: [
          { value: false, content: 'Horaire' },
          { value: true, content: 'Anti-horaire' },
        ],
        defaultValue: false,
      },
      recirculationRate: {
        type: 'number',
        label: 'Taux de recirculation',
        group: 'specific',
        path: 'customAttributes/recirculationRate',
        min: 0,
        max: 0,
        step: 0,
      },
      maxRecirculations: {
        type: 'number',
        label: 'Recirculations max',
        group: 'specific',
        path: 'customAttributes/maxRecirculations',
        min: 1,
        required: true,
      },
      theoreticalNumberOfPlaces: {
        type: 'number',
        label: 'Nombre de places théorique global',
        group: 'specific',
        path: 'customAttributes/theoreticalNumberOfPlaces',
        min: 1,
        required: true,
      },
      loadFactor: {
        type: 'number',
        label: 'Facteur de charge',
        group: 'specific',
        path: 'customAttributes/loadFactor',
        min: 0,
        max: 0,
        step: 0,
        required: true,
      },
      sorterType: {
        type: 'select-box',
        label: 'Type de trieur',
        group: 'specific',
        options: [
          { value: 'Bins', content: 'Bacs' },
          { value: 'Belt', content: 'A Cru' },
        ],
        path: 'linkType',
        defaultValue: 'Belt',
      },
      ports: {
        type: 'ports-editor',
        label: 'Ports',
        group: 'specific',
        path: 'ports/items',
      },
    },
    groups: commonGroups,
  },
  'appShapes.Stock': {
    inputs: {
      ...commonProperties,
      ...outagesProperties,
      theoreticalNumberOfPlaces: {
        type: 'number',
        label: 'Nombre de places',
        group: 'specific',
        path: 'customAttributes/theoreticalNumberOfPlaces',
        min: 1,
        required: true,
      },
      initialBinStock: {
        type: 'number',
        label: 'Stock initial de bacs',
        group: 'specific',
        path: 'customAttributes/initialBinStock',
        min: 0,
      },
      maxBaggagesPerFlightPerMinute: {
        type: 'number',
        label: 'Max bagages/vol/minute',
        group: 'specific',
        path: 'customAttributes/maxBaggagesPerFlightPerMinute',
        min: 1,
        defaultValue: 10000,
      },
      alpha: {
        type: 'number',
        label: 'Alpha',
        group: 'specific',
        path: 'customAttributes/alpha',
        min: 1,
      },
      useSameExitingProperties: {
        type: 'select-box',
        label: 'Propriétés de sortie identiques',
        group: 'specific',
        path: 'useSameExitingProperties',
        options: [
          { value: true, content: 'Oui' },
          { value: false, content: 'Non' },
        ],
        defaultValue: true,
      },
      exitingParallelism: {
        type: 'number',
        label: 'Parallélisme de sortie',
        group: 'specific',
        path: 'customAttributes/exitingParallelism',
        min: 1,
      },
      exitingCapacityPerHour: {
        type: 'number',
        label: 'Capacité de sortie (bagages/heure)',
        group: 'specific',
        path: 'customAttributes/exitingCapacityPerHour',
        min: 1,
      },
      acceptsEmptyBins: {
        type: 'select-box',
        label: 'Accepte les bacs vides',
        group: 'specific',
        path: 'sens',
        options: [
          { value: true, content: 'Oui' },
          { value: false, content: 'Non' },
        ],
        defaultValue: false,
      },
      ...destinationProperties,
    },
    groups: commonGroups,
  },
  'standard.Link': {
    inputs: {
      ...outagesProperties,
      linkType: {
        type: 'select-box',
        label: 'Type de transport',
        group: 'properties',
        options: [
          { value: 'bagage_bac', content: 'Bagage sur bac' },
          { value: 'bagage_cru', content: 'Bagage à cru' },
          { value: 'bac_vide', content: 'Bac vide' },
        ],
        path: 'linkType',
        defaultValue: 'bagage_bac',
      },
      useSpeed: {
        type: 'select-box',
        label: 'Définir la vitesse du transport',
        group: 'properties',
        options: [
          {
            value: false,
            content: 'Définir la durée du transport',
            tooltip: "La solution utilise la durée définie par l'utilisateur",
          },
          {
            value: true,
            content: 'Définir la vitesse du transport',
            tooltip:
              "La solution calcule la distance et applique la vitesse renseignée par l'utilisateur " +
              'pour définir la durée',
          },
        ],
        path: 'customAttributes/useSpeed',
        defaultValue: false,
      },
      length: {
        type: 'number',
        label: 'Longueur (pixels)',
        group: 'properties',
        path: 'length',
        readOnly: true,
      },
      distanceMeters: {
        type: 'number',
        label: 'Distance (m)',
        group: 'properties',
        path: 'customAttributes/distanceMeters',
        readOnly: true,
      },
      capacityPerHour: {
        type: 'number',
        label: 'Capacité Globale (unités/heure)',
        group: 'properties',
        path: 'customAttributes/capacityPerHour',
        required: true,
        min: 1,
      },
      parallelism: {
        type: 'number',
        label: 'Parallélisme',
        group: 'properties',
        path: 'customAttributes/parallelism',
        min: 1,
      },
      duration: {
        type: 'number',
        label: 'Durée (secondes)',
        group: 'properties',
        path: 'customAttributes/duration',
        required: true,
        min: 1,
      },
      speed: {
        type: 'number',
        label: 'Vitesse (m/s)',
        group: 'properties',
        path: 'customAttributes/speed',
        defaultValue: 1,
        required: true,
        min: 0,
        step: 0.1,
      },
    },
    groups: {
      properties: {
        label: 'Propriétés',
        index: 1,
      },
    },
  },
};
